import { createApp } from 'vue'
import App from './App.vue'
import router from "@/router";
import store from './store'
import VueCookies from 'vue-cookies'
import axios from "axios";
import VueAxios from "vue-axios";
import i18n from './i18n'
import { pickMessage } from '@/store/modules/messages'
import { applyAuthHeader, getJwt } from '@/session'

const app = createApp(App)


app.use(i18n)
app.use(router)
app.use(store)
app.use(VueCookies)
app.use(VueAxios, axios)
app.provide('axios', app.config.globalProperties.axios)
app.axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

// ТЕКСТЫ ОБУЧЕНИЯ РЕДАКТИРУЮТСЯ ИЗ АДМИНКИ (TUTORIAL_PLAN §8). `$tut('tut.<ключ>')` берёт строку из
// каталога сообщений (раздел `tutorial`), а если админ её не переопределял — из локали фронта.
// Формулировки обучения переписывают после наблюдения за живыми новичками, и это не должно
// требовать пересборки клиента.
app.config.globalProperties.$tut = function tutText(key, params) {
  const fallback = this.$t(key, params || {});
  const short = String(key).replace(/^tut\./, '');
  const raw = pickMessage(store.state.messages.catalog, `tutorial.${short}`, null);
  if (!raw) return fallback;
  if (!params) return raw;
  return String(raw).replace(/\{(\w+)\}/g, (m, name) => (params[name] != null ? params[name] : m));
};

// 🔴 Authorization обязан стоять ДО первого запроса ЛЮБОГО экрана. Дочерние компоненты монтируются
// РАНЬШЕ App.vue, который раньше и ставил заголовок из cookie: при перезагрузке страницы прямо на
// разделе (напр. /daily) его первый запрос уходил без токена → 401 → «Сеть недоступна».
// Токен берём через `@/session` (localStorage + cookie): в Telegram Web игра живёт в iframe, где
// cookie с `SameSite=Lax` браузер не отдаёт вовсе.
applyAuthHeader(axios, getJwt());

app.mount('#app')
